module.exports = __webpack_public_path__ + "img/style.5213bad2.svg";